// Mirrors apps/backend/src/modules/commission/commission.access.ts — keep in sync.
// Admin and finance only, both named — admin used to arrive through hasRole's
// wildcard. Viewer and bare internal: nothing.
import { hasRole } from "./roles";

export const canWriteCommissions = (roles: string[] | null | undefined) =>
  hasRole(roles, ["finance", "admin"]);

export const canReadCommissions = (roles: string[] | null | undefined) =>
  canWriteCommissions(roles);

// Agents see "My Commissions" and may open /commissions (ProtectedRoute). The API
// has its own switch (COMMISSION_STATEMENTS_ENABLED) and 404s while that is off.
export const AGENT_STATEMENTS_ENABLED = true;
